<template>
    <path
        fill="currentColor"
        d="M8 1L9.62 5.78L14.66 5.84L10.62 8.85L12.11 13.66L8 10.75L3.89 13.66L5.38 8.85L1.34 5.84L6.38 5.78Z"
    />
</template>
